@if (!isLoading) {
  <div class="site-loader-wrapper">
    <div class="loader"></div>
  </div>
}